export default "__VITE_ASSET__c53cc825__"